import { Stack, styled } from "@mui/material";

export const Flex = styled(Stack)({
  flexDirection: "row",
  display: "flex",
});
